<div class="conversation-icon-container" container="body" [ngbTooltip]="tooltip">
  <i [ngClass]="iconCls"></i>
</div>
